import config from "./config"
import api from './api'
import tool from './utils/tool'
import http from "./utils/request"
import { permission, rolePermission } from './utils/permission'

import mnArray from './components/mnArray'
import mnTable from './components/mnTable'
import scTableColumn from './components/mnTable/column.js'
import mnFilterBar from './components/mnFilterBar'
import mnUpload from './components/mnUpload'
import mnUploadMultiple from './components/mnUpload/multiple'
import mnUploadFile from './components/mnUpload/file'
import mnFormTable from './components/mnFormTable'
import mnTableSelect from './components/mnTableSelect'
import mnDialogSelectTable from './components/mnDialogSelectTable'
import mnPageHeader from './components/mnPageHeader'
import mnSelect from './components/mnSelect'
import mnDialog from './components/mnDialog'
import mnForm from './components/mnForm'
import mnXcx from './components/mnXcx'
import mnTitle from './components/mnTitle'
import mnTableNew from './components/mnTableNew'
import mnWaterMark from './components/mnWaterMark'
import mnQrCode from './components/mnQrCode'
import mnSearch from './components/mnSearch'
import save from './components/save'
import mnUploadImg from './components/mnUploadImg'

import mnStatusIndicator from './components/mnMini/mnStatusIndicator'
import mnTrend from './components/mnMini/mnTrend'
import mnFileSelectDialog from './components/mnFileSelectDialog'

import auth from './directives/auth'
import role from './directives/role'
import time from './directives/time'
import copy from './directives/copy'
import errorHandler from './utils/errorHandler'

import * as elIcons from '@element-plus/icons-vue'
import * as mnIcons from './icons'

export default {
	install(app) {
		//挂载全局对象
		app.config.globalProperties.$CONFIG = config;
		app.config.globalProperties.$TOOL = tool;
		app.config.globalProperties.$HTTP = http;
		app.config.globalProperties.$API = api;
		app.config.globalProperties.$AUTH = permission;
		app.config.globalProperties.$ROLE = rolePermission;

		//注册全局组件
		
		app.component('mnSearch', mnSearch);
		app.component('mnTable', mnTable);
		app.component('mnTableNew', mnTableNew);
		app.component('mnArray', mnArray);
		app.component('scTableColumn', scTableColumn);
		app.component('mnFilterBar', mnFilterBar);
		app.component('mnUpload', mnUpload);
		app.component('mnUploadMultiple', mnUploadMultiple);
		app.component('mnUploadFile', mnUploadFile);
		app.component('mnFormTable', mnFormTable);
		app.component('mnTableSelect', mnTableSelect);
		app.component('mnDialogSelectTable', mnDialogSelectTable);
		app.component('mnPageHeader', mnPageHeader);
		app.component('mnSelect', mnSelect);
		app.component('mnDialog', mnDialog);
		app.component('mnForm', mnForm);
		app.component('mnXcx', mnXcx);
		app.component('mnTitle', mnTitle);
		app.component('mnWaterMark', mnWaterMark);
		app.component('mnQrCode', mnQrCode);
		app.component('mnStatusIndicator', mnStatusIndicator);
		app.component('mnTrend', mnTrend);
		app.component('save',save)
		app.component('mnUploadImg',mnUploadImg)
		app.component('mnFileSelectDialog',mnFileSelectDialog)

		// //注册全局指令
		app.directive('auth', auth)
		app.directive('role', role)
		app.directive('time', time)
		app.directive('copy', copy)

		// //统一注册el-icon图标
		for(let icon in elIcons){
			app.component(`ElIcon${icon}`, elIcons[icon])
		}
		// //统一注册mn-icon图标
		for(let icon in mnIcons){
			app.component(`MnIcon${icon}`, mnIcons[icon])
		}

		// //关闭async-validator全局控制台警告
		// window.ASYNC_VALIDATOR_NO_WARNING = 1

		// //全局代码错误捕捉
		app.config.errorHandler = errorHandler
	}
}
